module.exports = "/img/videos/44.4699c0.mp4";